import Model, { encoders, ID, IsoDate } from 'src/models/model'
import PaymentConnectorConfiguration from 'src/models/payment-connector/PaymentConnectorConfiguration'

export default class PaymentConnectorTransactionNumber extends Model {
  static name = 'PaymentConnectorTransactionNumber'

  static paginate = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      transactionType: {
        type: String,
        default: null
      },
      startId: {
        type: String,
        default: null
      },
      endId: {
        type: String,
        default: null
      },
      startDate: {
        type: IsoDate,
        default: null
      },
      endDate: {
        type: IsoDate,
        default: null
      },
      paymentConnectorConfiguration: {
        type: PaymentConnectorConfiguration,
        default: null,
        encode: encoders.hasOne
      }
    }

    this.mutations = {
      getNextTransactionNumber: {
        results: {
          required: Boolean,
          transactionNumber: String
        }
      }
    }
  }
}
